module.exports = __webpack_public_path__ + "static/media/cedarmill.87637f9a.png";